import { captureMessage } from '@sentry/node';
import get from 'lodash/get';
import { useRouter } from 'next/router';

import PageTitle from '../Page Title/PageTitle';

import global from './generalLayout.module.scss';
import styles from './PageLayout.module.scss';

export default function PageLayout({ title = '', data = {} }) {
  const router = useRouter();

  const pageData = get(data, 'data[0]');
  if (!pageData) {
    captureMessage(`Invalid page data for ${router.asPath}`);
    return null;
  }

  const sections = pageData?.fields?.sections;
  if (!pageData) {
    captureMessage(`Invalid page sections for ${router.asPath}`);
    return null;
  }

  const imgSrc = get(sections, '[0].image.path', '');
  const imgTitle = pageData.title || title || '';

  return (
    <>
      <PageTitle title={title} />

      <section className={styles.section}>
        <div className={global.container}>
          <div className={global.row}>
            {imgSrc && (
              <div className={styles.imageContainer}>
                <img className={styles.img} src={imgSrc} alt={imgTitle} />
              </div>
            )}

            <div className={styles.content}>
              {sections.map(({ uuid, heading, text }) => (
                <div key={uuid}>
                  <h2 className={styles.sectionHeading} dangerouslySetInnerHTML={{ __html: heading }} />
                  <div className={styles.sectionText} dangerouslySetInnerHTML={{ __html: text }} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
